import { render, staticRenderFns } from "./emptyRouterComponent.vue?vue&type=template&id=9942ad70&scoped=true&lang=pug"
import script from "./emptyRouterComponent.vue?vue&type=script&lang=js"
export * from "./emptyRouterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9942ad70",
  null
  
)

export default component.exports